import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GameCard from './GameCard';
const ConfidenceTiers = ({ games }) => {
    // Early return if games is not available
    if (!games || games.length === 0) {
        return (_jsx("div", { className: "text-center py-5", children: _jsx("div", { className: "spinner-border", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }) }));
    }
    // Helper function to get bet grade color (same as MLB)
    const getBetGradeColor = (grade) => {
        if (!grade)
            return '#6c757d';
        const gradeUpper = grade.toUpperCase();
        if (gradeUpper.startsWith('A'))
            return '#198754'; // Green
        if (gradeUpper.startsWith('B'))
            return '#0dcaf0'; // Light blue
        if (gradeUpper.startsWith('C'))
            return '#ffc107'; // Yellow
        if (gradeUpper.startsWith('D'))
            return '#fd7e14'; // Orange
        if (gradeUpper.startsWith('F'))
            return '#dc3545'; // Red
        return '#6c757d';
    };
    // Create bet grade tiers (like MLB)
    const aGradeGames = games.filter(g => g.betting_indicators?.bet_ranking?.grade?.toUpperCase().startsWith('A'));
    const bGradeGames = games.filter(g => g.betting_indicators?.bet_ranking?.grade?.toUpperCase().startsWith('B'));
    const cGradeGames = games.filter(g => g.betting_indicators?.bet_ranking?.grade?.toUpperCase().startsWith('C'));
    const dGradeGames = games.filter(g => g.betting_indicators?.bet_ranking?.grade?.toUpperCase().startsWith('D'));
    const fGradeGames = games.filter(g => g.betting_indicators?.bet_ranking?.grade?.toUpperCase().startsWith('F'));
    const tiers = [
        {
            tier: 'A_GRADE',
            label: 'A-Grade Opportunities',
            color: '#198754', // Green
            games: aGradeGames,
            description: 'Elite betting opportunities with strong fundamentals',
            bankroll_range: '2-5%'
        },
        {
            tier: 'B_GRADE',
            label: 'B-Grade Opportunities',
            color: '#0dcaf0', // Light blue
            games: bGradeGames,
            description: 'Good betting opportunities with solid value',
            bankroll_range: '1-2%'
        },
        {
            tier: 'C_GRADE',
            label: 'C-Grade Opportunities',
            color: '#ffc107', // Yellow
            games: cGradeGames,
            description: 'Average opportunities - proceed with caution',
            bankroll_range: '0.5-1%'
        },
        {
            tier: 'D_GRADE',
            label: 'D-Grade Opportunities',
            color: '#fd7e14', // Orange
            games: dGradeGames,
            description: 'Below-average opportunities - avoid betting',
            bankroll_range: 'Skip'
        },
        {
            tier: 'F_GRADE',
            label: 'F-Grade / Avoid',
            color: '#dc3545', // Red
            games: fGradeGames,
            description: 'Failed opportunities - never bet these',
            bankroll_range: 'Never'
        }
    ];
    return (_jsxs("div", { className: "confidence-tiers", children: [tiers.map((tier) => {
                if (tier.games.length === 0)
                    return null;
                return (_jsxs("div", { className: "tier-section mb-5", children: [_jsx("div", { className: "tier-header mb-4", children: _jsxs("div", { className: "d-flex justify-content-between align-items-center", children: [_jsxs("div", { children: [_jsxs("h3", { className: "mb-1 text-body-emphasis", style: { fontWeight: '600' }, children: [_jsx("i", { className: "fas fa-trophy me-2", style: { color: tier.color } }), tier.label] }), _jsxs("p", { className: "text-muted mb-0", children: [tier.games.length, " game", tier.games.length !== 1 ? 's' : '', " \u2022", tier.description, " \u2022 Bankroll: ", tier.bankroll_range] })] }), _jsx("div", { className: "tier-badge", children: _jsx("span", { className: "badge bg-light text-dark fs-6 px-3 py-2", style: {
                                                border: `2px solid ${tier.color}`,
                                                color: tier.color,
                                                backgroundColor: 'var(--bs-body-bg)'
                                            }, children: tier.games.length }) })] }) }), _jsx("div", { className: "row g-4", children: tier.games
                                .sort((a, b) => {
                                // First sort by grade_rank within the same grade (lower rank = better)
                                const rankA = a.betting_indicators?.bet_ranking?.grade_rank || 999;
                                const rankB = b.betting_indicators?.bet_ranking?.grade_rank || 999;
                                if (rankA !== rankB)
                                    return rankA - rankB;
                                // Then by composite score (higher score = better)
                                const scoreA = a.betting_indicators?.bet_ranking?.composite_score || 0;
                                const scoreB = b.betting_indicators?.bet_ranking?.composite_score || 0;
                                return scoreB - scoreA;
                            })
                                .map((game) => (_jsx("div", { className: "col-12 col-md-6 col-xl-4", children: _jsx(GameCard, { game: game, tierColor: tier.color }) }, game.id))) })] }, tier.tier));
            }), games.length === 0 && (_jsxs("div", { className: "text-center py-5", children: [_jsx("i", { className: "fas fa-search fa-3x text-muted mb-3" }), _jsx("h4", { className: "text-muted", children: "No games found" }), _jsx("p", { className: "text-muted", children: "Try adjusting your filters to see more games." })] }))] }));
};
export default ConfidenceTiers;
